import { Box, CircularProgress } from '@packages/shared';

/**
 * This component displays Loader on Service Layer
 * @returns JSX.Element to be placed in Service Layer
 */
export const ServiceLayerLoader = (): JSX.Element => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      height: '100%',
    }}
  >
    <CircularProgress size="m" />
  </Box>
);
